/* eslint-disable react/jsx-no-bind */
import React, { useState } from 'react';
import { Button, MenuItem } from '@mui/material';
import Menu from '@mui/material/Menu';
import { Link } from 'gatsby';

const MenuElement = ({ menuTitle, id, title, nodes }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  function handleClick(event) {
    setAnchorEl(event.currentTarget);
  }
  function handleClose() {
    setAnchorEl(null);
  }

  return (
    <>
      <Button
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
        size="large"
        title={title}
      >
        {menuTitle}
      </Button>
      <Menu
        id={id}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {nodes.map(page => (
          <MenuItem
            key={page.contentful_id}
            onClick={handleClose}
            component={Link}
            to={`/${page.slug}/`}
          >
            {page.shortName}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default MenuElement;
